<div class="mainContainer">
    <div class="filter_show">
        <div class="log_track mr-header-row">
            <span class="mr-header-title">Meal Request</span>
            <span class="mr-campus-name" *ngIf="campusName">Building Name : {{ campusName }}</span>
        </div>
        <div class="kitchen_row">
            <div class="field__label">
                Select Kitchen
            </div>
            <select class="field__control dropdown" [(ngModel)]="selectedSupplyId"
                (ngModelChange)="onKitchenChange($event)">
                <option *ngFor="let k of kitchens" [ngValue]="k.supplyId">
                    {{ getKitchenOptionLabel(k) }}
                </option>
            </select>
            <!-- <div class="mr-request-history" *ngIf="rowData?.length">
                <span class="mr-request-history__label">Request History</span>
                <span class="mr-request-history__count">{{ rowData.length }}</span>
            </div> -->
        </div>
    </div>

    <div class="mess-box">
        <div class="icon_flex">
            <p class="stock_title">Meal Request Date :</p>
            <input matInput [matDatepicker]="mydate" [min]="minDate" [max]="maxDate" (click)="mydate.open()"
                [value]="current" (dateChange)="onStockDateChange($event)" class="form-control form-date"
                placeholder="Stock Date" readonly />

            <mat-datepicker-toggle matSuffix [for]="mydate" class="datepic"></mat-datepicker-toggle>
            <mat-datepicker #mydate [dateClass]="daysheetDateClass"></mat-datepicker>

            <!-- <p class="search_title">Search :</p>
            <input type="text" placeholder="Search" (input)="onfilterChange($event)"
                class="form-control search_input" /> -->


<!-- 
            <button mat-raised-button type="button" class="add_item_btn" (click)="addMealRequest()"
                [disabled]="isAddMealRequestDisabled">
                Add Meal Request
            </button> -->

            <button type="button" class="add_item_btn"   (click)="addMealRequest()"  [disabled]="isAddMealRequestDisabled">
                <mat-icon class="mi-add-holiday-btn__icon">add</mat-icon>
                <span> Add Meal Request</span>
            </button>

        </div>
        <!-- Table (ABOVE date-picker row as requested) -->
        <div class="content" style="width: 100%; height: 35%;">
            <ag-grid-angular style="width: 100%; height: 280px;" [rowData]="rowData" [pinnedBottomRowData]="pinnedBottomRowData"
                [columnDefs]="colDefs" [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)" (rowClicked)="onMealRequestRowClicked($event)"
                [rowHeight]="45"
                [quickFilterText]="quickFilter" [overlayLoadingTemplate]="overlayLoadingTemplate"
                [overlayNoRowsTemplate]="overlayNoRowsTemplate" />
        </div>

        <!-- Controls (date-picker + search + add item) -->

    </div>
</div>

<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>